import React from 'react'
import { useDataGovernorsPage } from './DataGovernorsPage.logic'
import { useStyles } from './DataGovernorsPage.style'
import { AddGovernorDialog } from './AddGovernorDialog/AddGovernorDialog'
import { AssignmentRegistryCard } from './AssignmentRegistryCard/AssignmentRegistryCard'
import { EnvironmentTabsRow } from './EnvironmentTabsRow/EnvironmentTabsRow'
import { RegistryFilterPanel } from './RegistryFilters/RegistryFilterPanel'
import { RegistryFilters } from './RegistryFilters/RegistryFilters'
import { useRegistryFilters } from './RegistryFilters/RegistryFilters.logic'
import { RegistrySummary } from './RegistrySummary/RegistrySummary'
import { RemoveGovernorDialog } from './RemoveGovernorDialog/RemoveGovernorDialog'

export const DataGovernorsPage: React.FC = () => {
  const { classes, cx } = useStyles()
  const {
    activeTab,
    intEnvironment,
    setIntEnvironment,
    environment,
    governors,
    hubFriendlyNames,
    isLoading,
    hasLoaded,
    error,
    setError,
    notice,
    setNotice,
    searchText,
    setSearchText,
    hubFilter,
    setHubFilter,
    businessObjectFilter,
    setBusinessObjectFilter,
    isAddDialogOpen,
    governorToRemove,
    setGovernorToRemove,
    hubOptions,
    businessObjectOptions,
    hubCount,
    filteredGovernors,
    selectTab,
    openAddDialog,
    closeAddDialog,
    closeRemoveDialog,
    handleGovernorAdded,
    handleGovernorRemoved,
  } = useDataGovernorsPage()

  const registryFilters = useRegistryFilters({
    hubFilter,
    onHubFilterChange: setHubFilter,
    businessObjectFilter,
    onBusinessObjectFilterChange: setBusinessObjectFilter,
    hubOptions,
    businessObjectOptions,
    hubFriendlyNames,
  })

  return (
    <section className={cx(classes.root)}>
      <EnvironmentTabsRow
        classes={classes}
        activeTab={activeTab}
        intEnvironment={intEnvironment}
        onSelectTab={selectTab}
        onIntEnvironmentChange={setIntEnvironment}
      />

      <div className={classes.summaryRow}>
        <RegistrySummary
          classes={classes}
          assignmentCount={governors.length}
          hubCount={hubCount}
          onAddGovernor={openAddDialog}
        />
        <RegistryFilters
          classes={classes}
          searchText={searchText}
          onSearchTextChange={setSearchText}
          onOpenFilters={registryFilters.openDialog}
        />
      </div>

      <div className={classes.activeFiltersRow}>
        <RegistryFilterPanel
          isOpen={registryFilters.isDialogOpen}
          facets={registryFilters.facets}
          selectedValues={registryFilters.selectedValues}
          onApply={registryFilters.applyValues}
          onOpenDialog={registryFilters.openDialog}
          onCloseDialog={registryFilters.closeDialog}
          onFacetCleared={registryFilters.clearFacet}
          onClearAll={registryFilters.clearAll}
        />
      </div>

      <AssignmentRegistryCard
        classes={classes}
        filteredGovernors={filteredGovernors}
        hubFriendlyNames={hubFriendlyNames}
        isLoading={isLoading}
        hasLoaded={hasLoaded}
        error={error}
        onDismissError={() => setError(null)}
        notice={notice}
        onDismissNotice={() => setNotice(null)}
        onRemoveRequested={(governor) => {
          setError(null)
          setGovernorToRemove(governor)
        }}
      />

      <AddGovernorDialog
        classes={classes}
        isOpen={isAddDialogOpen}
        activeTab={activeTab}
        defaultHub={hubFilter}
        defaultBusinessObject={businessObjectFilter}
        defaultEnvironment={intEnvironment}
        hubOptions={hubOptions}
        businessObjectOptions={businessObjectOptions}
        hubFriendlyNames={hubFriendlyNames}
        onClose={closeAddDialog}
        onGovernorAdded={handleGovernorAdded}
      />

      <RemoveGovernorDialog
        classes={classes}
        governor={governorToRemove}
        environment={environment}
        hubFriendlyNames={hubFriendlyNames}
        onClose={closeRemoveDialog}
        onGovernorRemoved={handleGovernorRemoved}
      />
    </section>
  )
}
